import Request from "@/services/request/index";

// 考生端 - 我的站内信（后端 /app/exam/notify-message/*）
export const getMyNotifyMessagePage = (data) => {
  return Request.get({ url: "/app/exam/notify-message/my-page", params: data });
};

export const updateNotifyMessageRead = (ids) => {
  // 后端为 @RequestParam("ids") List<Long>，需按 "1,2" 逗号拼接（axios 0.18 对数组会序列化成 ids[]=1，无法绑定）
  const idParam = Array.isArray(ids) ? ids.join(",") : ids;
  return Request.put({ url: "/app/exam/notify-message/update-read", params: { ids: idParam } });
};

export const updateAllNotifyMessageRead = () => {
  return Request.put({ url: "/app/exam/notify-message/update-all-read" });
};

export const getUnreadNotifyMessageList = (size = 10) => {
  return Request.get({ url: "/app/exam/notify-message/get-unread-list", params: { size } });
};

export const getUnreadNotifyMessageCount = () => {
  return Request.get({ url: "/app/exam/notify-message/get-unread-count" });
};
